import Image1 from '../../assets/flytbase_logo.png'
import Image2 from '../../assets/barclays_logo.png'
import Image3 from '../../assets/phn_logo.png'

export const Data = [
  {
    id: 1,
    image: Image2,
    title: 'Barclays - Full time',
    description:
      'Currently working as a Developer in the Mercury Team under the Research IT Department at Barclays.',
    date: '07/23 - Present',
    location: 'Pune, Maharashtra',
    position: 'Developer',
    skills: 'Spring Boot | Java | MS SQL | Angular',
  },
  {
    id: 2,
    image: Image1,
    title: 'Flytbase - Internship',
    description:
      "As a Software Development Intern at Flytbase Labs, a Drone Autonomy Software Company, I am actively involved in enhancing software features for automated drone operations. Collaborating with the team, I contribute to developing functionalities for drone docks, enabling efficient site security, asset inspection, and emergency response capabilities. This experience is strengthening my skills in software development and automation technologies while contributing to Flytbase's innovative solutions.",
    date: '02/24 - 7/24',
    location: 'Pune, Maharashtra',
    position: 'Software Development Intern',
    skills: 'Angular | NestJS | MongoDB',
  },
  {
    id: 3,
    image: Image2,
    title: 'Barclays - Internship',
    description:
      'During my Barclays internship, I built a Spring Boot web app with REST APIs called Data Migration Utility. It moved multilingual data from DB2 to Microsoft SQL efficiently, with adjustable constraints, batch sizes, and real-time progress tracking. I also developed an Index Keys Comparison tool and a Data Validation tool, offering customizable sampling and downloadable output reports. This enhanced my proficiency in full-stack development.',
    date: '06/23 - 08/23',
    location: 'Pune, Maharashtra',
    position: 'Developer Intern',
    skills:
      'Spring Boot | Spring JDBC | Java | DB2 | MS SQL | HTML | CSS | JavaScript | Rest APIs',
  },
  {
    id: 4,
    image: Image3,
    title: 'PHN Technology - Internship',
    description:
      'During my internship at PHN Technology Pvt. Ltd., I completed the Web Development program and worked upon the different technologies like HTML, CSS, Javascript and ReactJS. I actively contributed to various projects, showcasing adaptability, and a willingness to learn. This experience has further enhanced my skills and solidified my passion for web development.',
    date: '04/23 - 06/23',
    location: 'Remote',
    position: 'Web Development Intern',
    skills: 'HTML | CSS | Bootstrap | Javascript | ReactJS ',
  },
]
